import { BannerProps, useBanner } from '.';
import Button from '../button';
import Text from '../text';
import customTwMerge from '@rc/utils/twMerge';
import Icon from '@rc/Icon';

export const Banner = ({ title, description, iconProps, cta, onCtaClick, className }: BannerProps) => (
  <div
    className={customTwMerge(
      'flex flex-col md:flex-row gap-4 p-4 mt-2 rounded-lg border bg-red-10 border-red-100',
      className?.container
    )}
  >
    <div className="flex flex-row gap-2">
      {iconProps ? <Icon {...iconProps} /> : null}
      <div>
        <Text className={customTwMerge('mr-8', className?.title)} type="header-3">
          {title}
        </Text>
        <Text className={customTwMerge('mr-8', className?.description)}>{description}</Text>
      </div>
    </div>
    {onCtaClick ? (
      <Button
        className={customTwMerge('md:ml-auto justify-center whitespace-nowrap', className?.cta)}
        onClick={() => onCtaClick()}
      >
        {cta ?? 'Learn more'}
      </Button>
    ) : null}
  </div>
);

const BannerContainer = () => {
  const [banner] = useBanner();
  return banner && <Banner {...banner} />;
};

export default BannerContainer;
